import { useGlobalDIContext } from '@context/GlobalDIContext';
import { useCheckAuth, useGetUserInfo } from '@features/user/states';
import { useGetClientPermission } from '@features/user/states/queries/useGetClientPermission';
import { Box } from '@mui/system';

function WuLayoutMobileMenuUserCard() {
  const { TranslationAdapter } = useGlobalDIContext();
  const { t } = TranslationAdapter();
  const { isAuthenticated } = useCheckAuth();
  const { hasSubService } = useGetClientPermission(!!isAuthenticated);
  const { user } = useGetUserInfo(hasSubService('WUD'));

  return (
    <Box
      sx={{
        px: '20px',
        py: '16px',
        mt: 5,
        borderRadius: '12px',
        backgroundColor: '#919EAB14',
        display: 'flex',
        justifyContent: 'center',
        gap: '16px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#181818',
          width: 36,
          height: 36,
          borderRadius: 16,
          color: '#FD0',
          fontFamily: 12,
          '& span': {
            marginTop: '3px',
          },
        }}
      >
        <span>
          {user?.personalDetails.firstName?.charAt(0).toUpperCase() ?? '-'}
          {user?.personalDetails.lastName?.charAt(0).toUpperCase() ?? '-'}
        </span>
      </Box>
      <Box>
        <Box sx={{ fontWeight: 600, fontSize: 14, color: '#212B36' }}>
          {user?.personalDetails.firstName ?? 'Unknown'}{' '}
          {user?.personalDetails.lastName ?? 'Unknown'}
        </Box>
        <Box sx={{ fontWeight: 400, fontSize: 14, color: '#919EAB' }}>{t('verified')}</Box>
      </Box>
    </Box>
  );
}

export default WuLayoutMobileMenuUserCard;
